export const defaultConfig = {
    lat: 37.8185082,
    lng: -122.4863585,
    zoom: 10,
    boxSize: 150,
    boxScale: 2,
    verticalScale: 3,
    baseHeight: 3,
    waterDrop: 2,
    modelScale: 1
};



// WEBPACK FOOTER //
// ./src/defaultConfig.js